import { render, staticRenderFns } from "./CustomQuestionAnswerFileUploads.vue?vue&type=template&id=1e5ad84a"
import script from "./CustomQuestionAnswerFileUploads.vue?vue&type=script&lang=js"
export * from "./CustomQuestionAnswerFileUploads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports